var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import model from '../base.model';
import { isIPAddress, isNumber } from '../../utils/validation.helper';
import { isEmpty } from '../../utils/helpers';
import { GLOBAL_TYPES } from '../../device/types/global.types';
import { COST_MODE } from '../../services/core/cost/cost.constant';

class settingsModelForm extends model {

    //region init

    static create() {
        return _extends({}, super.create(), {
            settings: {},
            serverIPError: '',
            serverPortError: '',
            isValid: true,
            costMode: COST_MODE.WATT
        });
    }

    //endregion

    //region form

    static validate(modelData) {
        const { settings } = modelData;
        let serverIP = settings[GLOBAL_TYPES.SERVER_IP];
        let serverPort = settings[GLOBAL_TYPES.SERVER_PORT];

        let serverIPError = isEmpty(serverIP) ? 'Empty' : '';
        let serverPortError = isEmpty(serverPort) ? 'Empty' : isNumber(serverPort);

        serverIPError = serverIPError && 'Please check the correctness of the server address';
        serverPortError = serverPortError && 'Please check the correctness of the server port';

        const isValid = !serverIPError && !serverPortError;
        if (serverIPError) {
            serverIP = '';
        }
        if (serverPortError) {
            serverPort = '';
        }

        return {
            [GLOBAL_TYPES.SERVER_IP]: serverIP,
            serverIPError,
            [GLOBAL_TYPES.SERVER_PORT]: serverPort,
            serverPortError,
            isValid
        };
    }

    static getPlaceholders(modelData, error) {
        const { settings } = modelData;
        const {
            serverIPError,
            serverPortError,
            isValid
        } = modelData;

        let serverIPPlaceholder = 'Server ip address';
        let serverPortPlaceholder = 'Server port';
        let costModePlaceholder = 'Cost mode';

        return {
            costModePlaceholder,
            serverIPPlaceholder,
            serverPortPlaceholder
        };
    }

    //endregion

    //region actions

    static actionOnChangeCostMode(model, costMode) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CHANGE_COST_MODE,
                payload: {
                    model,
                    [GLOBAL_TYPES.COST_MODE]: costMode
                }
            });
        };
    }

    static actionOnChangeServerIP(model, serverIP) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CHANGE_SERVER_IP,
                payload: {
                    model,
                    [GLOBAL_TYPES.SERVER_IP]: serverIP
                }
            });
        };
    }

    static actionOnChangeServerPort(model, serverPort) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CHANGE_SERVER_PORT,
                payload: {
                    model,
                    [GLOBAL_TYPES.SERVER_PORT]: serverPort
                }
            });
        };
    }

    static actionOnClearForm(model) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_CLEAR_FORM,
                payload: { model }
            });
        };
    }

    static actionOnValidate(model, form) {
        return dispatch => {
            return dispatch({
                type: model.TYPE_ON_VALIDATE_FORM,
                payload: { model, form }
            });
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_ON_CLEAR_FORM]: model.reduceOnClearForm.bind(model),
            [model.TYPE_ON_VALIDATE_FORM]: model.reduceOnValidateForm.bind(model),
            [model.TYPE_ON_CHANGE_SERVER_IP]: model.reduceOnChangeServerIP.bind(model),
            [model.TYPE_ON_CHANGE_SERVER_PORT]: model.reduceOnChangeServerPort.bind(model),
            [model.TYPE_ON_CHANGE_COST_MODE]: model.reduceOnChangeCostMode.bind(model)
        };

        return reducers[type];
    }

    static reduceOnClearForm(stateModel, action) {
        const { model, clientModel } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, model.create(), clientModel)
        };
    }

    static reduceOnValidateForm(stateModel, action) {
        const { model, form } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, form)
        };
    }

    static reduceOnChangeCostMode(stateModel, action) {
        const { model } = action.payload;
        const costMode = action.payload[GLOBAL_TYPES.COST_MODE];
        const { settings } = stateModel;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                settings: _extends({}, settings, {
                    isValid: true,
                    [GLOBAL_TYPES.COST_MODE]: costMode
                })
            })
        };
    }

    static reduceOnChangeServerIP(stateModel, action) {
        const { model } = action.payload;
        const serverIP = action.payload[GLOBAL_TYPES.SERVER_IP];
        const { settings } = stateModel;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                settings: _extends({}, settings, {
                    isValid: true,
                    [GLOBAL_TYPES.SERVER_IP]: serverIP,
                    serverIPError: ''
                })
            })
        };
    }

    static reduceOnChangeServerPort(stateModel, action) {
        const { model } = action.payload;
        const serverPort = action.payload[GLOBAL_TYPES.SERVER_PORT];
        const { settings } = stateModel;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                settings: _extends({}, settings, {
                    isValid: true,
                    [GLOBAL_TYPES.SERVER_PORT]: serverPort,
                    serverPortError: ''
                })
            })
        };
    }
}

settingsModelForm.MODEL_NAME = 'settingsModel';
settingsModelForm.TYPE_ON_CHANGE_SERVER_IP = 'TYPE_SETTINGS__ON_CHANGE_SERVER_IP';
settingsModelForm.TYPE_ON_CHANGE_SERVER_PORT = 'TYPE_SETTINGS__ON_CHANGE_SERVER_PORT';
settingsModelForm.TYPE_ON_CLEAR_FORM = 'TYPE_SETTINGS__ON_CLEAR_FORM';
settingsModelForm.TYPE_ON_VALIDATE_FORM = 'TYPE_SETTINGS__ON_VALIDATE_FORM';
settingsModelForm.TYPE_ON_CHANGE_COST_MODE = 'TYPE_ON_CHANGE_COST_MODE';
export { settingsModelForm };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/service/settings.model.form.js